<template>
  <div class="header">
    <logos></logos>
    <header-title
      @setactivemenu="navigateBottomMenu"
      :titleState="headerTopLine"
      :choosenMenuName="choosenMenuName"
    ></header-title>
    <header-subtitle
      v-if="isSecWithContent() === false"
      :subtitleState="headerBottomLine"
      :choosenSubmenuItems="choosenSubmenuItems"
    ></header-subtitle>
  </div>
</template>

<script>
import Logos from '@/components/Logo/Logos';
import HeaderTitle from '@/components/ContentHeader/HeaderTitle/HeaderTitle';
import HeaderSubtitle from '@/components/ContentHeader/HeaderSubtitle/HeaderSubtitle';
import Clicks from '@/components/ContentHeader/mixins/clicks';
import Animations from '@/components/ContentHeader/mixins/animations';
import { psoriasis as psoriasisSections } from '@/data/sections';
import { tremfya as tremfyaSections } from '@/data/sections';

export default {
  data() {
    return {
      headerTopLine: 'basic', // '' basic' 'burger' 'menu' 'title' 'footer' 'section-1'
      headerBottomLine: 'basic', // '' 'basic' 'burger' 'menu' 'scrolled'
      choosenMenuName: '',
      choosenSubmenuItems: []
    };
  },
  mixins: [Clicks, Animations],
  components: {
    Logos,
    'header-title': HeaderTitle,
    'header-subtitle': HeaderSubtitle
  },
  name: 'content-header',
  watch: {
    '$store.state.headerStatus'(val) {
      if (val === 'basic') {
        this.headerTopLine = 'basic';
        this.headerBottomLine = 'basic';
      }
    },
    $route() {
      if (this.$store.state.headerStatus === 'openSubmenu') {
        this.headerTopLine = 'basic';
        this.headerBottomLine = 'basic';
      }
      this.handleMenuViewOnNavigation(); // comment me for menu
    },
    headerState: {
      handler: function(newValue) {
        if (newValue === 'basic-large,menu-auto') {
          this.$store.commit('setHeaderStatus', 'openSubmenu');
          return;
        }
        if (newValue === 'basic,scrolled') {
          this.$store.commit('setHeaderStatus', 'title');
          return;
        }
        if (
          newValue !== 'basic,basic' &&
          newValue !== 'burger,basic' &&
          newValue !== 'burger,burger' &&
          newValue !== 'basic,burger'
        ) {
          this.$store.commit('setHeaderStatus', 'menu');
          return;
        }
        this.$store.commit('setHeaderStatus', 'basic');
      },
      immediate: true
    }
  },
  methods: {
    handleMenuViewOnNavigation() {
      if (
        this.$route.name.includes('-section') &&
        this.$route.params.section === '1'
      ) {
        this.headerTopLine = 'title';
        this.headerBottomLine = '';
        return;
      }
      if (
        this.$route.name.includes('-section') &&
        this.$store.getters.activeSection.name !== 'footer'
      ) {
        this.headerTopLine = 'section-1';
        this.headerBottomLine = '';
        return;
      }
      if (
        this.$route.name.includes('-section') &&
        this.$store.getters.activeSection.name === 'footer' &&
        this.$store.getters.page === 'psoriasis'
      ) {
        this.headerTopLine = 'footer';
        this.headerBottomLine = '';
        return;
      }
      if (
        this.$route.name.includes('-section') &&
        this.$store.getters.activeSection.name === 'footer' &&
        this.$store.getters.page === 'tremfya'
      ) {
        this.headerTopLine = 'footer';
        this.headerBottomLine = 'footer';
        return;
      }
      if (this.$route.name.includes('-subsection')) {
        this.headerTopLine = 'basic';
        this.headerBottomLine = 'basic';
        return;
      }
    },
    isSecWithContent() {
      // console.log('isSecWithContent()');
      if (
        this.$route.name.includes('-section') &&
        this.$store.getters.page === 'tremfya' &&
        (this.$route.params.section === '4' ||
          this.$route.params.section === '5')
      ) {
        return true;
      }
      return false;
    }
  },
  computed: {
    headerState() {
      return [this.headerTopLine, this.headerBottomLine].join(',');
    },
    sections() {
      if (this.$route.meta.page === 'Psoriasis') {
        return psoriasisSections;
      } else if (this.$route.meta.page === 'Tremfya') {
        return tremfyaSections;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.handleMenuViewOnNavigation();
    });
  }
};
</script>
<style lang="scss" src="./ContentHeader.scss">
</style>
